<template>
	<div class="dues-conversation">
		<div v-if="loading" class="text-center" style="padding: 10px;">
			<span class="spinner"></span> Loading conversation...
		</div>
		<div v-else-if="error" class="text-center" style="padding: 10px; color: red;">
			Unable to load conversation
			<button class="btn btn-primary btn-xs" @click="fetchconversation()">Retry</button>
		</div>
		<div v-else-if="commentlist.length == 0" class="text-center" style="padding: 10px;">
			No messages found
		</div>
		<table v-else class="table table-bordered table-font table-comment">
			<thead style="color: #008787;">
				<tr>
					<th>S.No</th>
					<th>Message</th>
					<th>Followed By</th>
					<th>Pay Date</th>
					<th>Entry Date</th>
					<th>Entry By</th>
					<th>Approved By</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in commentlist" :key="item.id">
					<td>{{ index + 1 }}</td>
					<td style="white-space: pre-line;">{{ item.comments }}</td>
					<td>{{ item.visitor != null ? item.visitor.name : '' }}</td>
					<td>{{ item.nextpaymentdate ? moment(item.nextpaymentdate).format("DD-MM-YYYY") : '' }}</td>
					<td>{{ moment(item.created_at).format("DD-MM-YYYY") }} <br> {{ moment(item.created_at).format("hh:mm A") }}</td>
					<td>{{ item.enteredby != null ? item.enteredby.name : '' }}</td>
					<td>
						<span v-if="item.approvestatus == 1" style="color: green">{{ item.approvedby != null ? item.approvedby.name : 'Approved' }}</span>
						<span v-else-if="item.approvestatus == 2" style="color: red">Declined</span>
						<span v-else>Not Approved</span>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
import moment from "moment";
export default {
	props: ["emiid"],
	data() {
		return {
			moment: moment,
			commentlist: [],
			loading: false,
			error: false
		};
	},
	mounted() {
		// fetched fresh every time the conversation is opened
		this.fetchconversation();
	},
	methods: {
		fetchconversation() {
			this.loading = true;
			this.error = false;
			this.$http.post('api/vsdigi/dues/conversation', { emiid: this.emiid })
				.then((response) => {
					this.commentlist = response.data || [];
				})
				.catch((err) => {
					console.log(err);
					this.error = true;
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>
<style scoped>
.dues-conversation {
	padding: 10px;
}

.table-comment {
	margin-bottom: 0;
	font-size: 14px !important;
	background-color: #fff;
}
</style>
